import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './OurServices.scss';
import { Formik ,  Field , Form } from 'formik';

import ServiceIcon1 from '../../images/services-icons-1.svg';
import ServiceIcon2 from '../../images/services-icons-2.svg';
import Harbor from '../../images/harbor.svg';
import ZMPCLoader from '../../images/zmpc-loader.svg';
import AllEquips from '../../images/all-eqips.svg';
import ShipGear from '../../images/ship-gear.svg';
import CallSvg from '../../images/call-svg.svg';
import MailSvg from '../../images/mail-svg.svg';
import LocationSvg from '../../images/location-svg.svg';
import { contactFormValidation } from '../Re-usable/Validation';
import emailjs from 'emailjs-com';
import ErrorSvg from '../../images/error-svg.svg';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const OurServices = () => {

  const navigate = useNavigate()

  const [message , setMessage] = useState('')

  const canonicalUrl = "https://whitetowerinternational.com/Services";

  const ourServicesContactForm = {
    name: '',
    phone: '',
    email: ''
  }

  const ourServicesCards = [
    {
      title: 'Vessel Operations',
      content: 'We provide top-notch vessel operations, specializing in loading and unloading with an expert stevedoring team. With over 10 years of experience, we ensure efficient, reliable services for smooth operations.',
      icon: ServiceIcon2,
    },
    {
      title: 'Harbour mobile crane operators',
      content: 'We provide trained harbour mobile crane operators who manage loading and unloading processes with precision. Their expertise ensures that cargo operations run smoothly, reducing waiting times and increasing port efficiency.',
      icon: Harbor,
    },
    {
      title: 'ZMPC loader & unloader operators',
      content: "Our highly skilled ZMPC loader and unloader operators ensure safe, efficient cargo handling for smooth port operations. With years of experience, they guarantee precise loading and unloading to meet your port's operational needs.",
      icon: ZMPCLoader,
    },
    {
      title: 'Ship Gear Operators',
      content: "Our Ship gear operators manage ship-based equipment, overseeing the careful loading and unloading of cargo. Their experience ensures that all operations are carried out safely, minimizing risks and maximizing port productivity.",
      icon: ShipGear,
    },
    {
      title: 'All type of Equipment Operators',
      content: "We supply qualified equipment operators trained in multiple machinery types, from forklifts to cranes. Their efficiency and safety-conscious approach contribute significantly to successful project execution in various industries.",
      icon: AllEquips,
    },
    {
      title: 'Cargo Discrimination',
      content: "We deliver cargo discrimination services that assess and classify various goods. This meticulous approach ensures efficient management throughout the logistics process, enhancing operational productivity and minimizing handling errors.",
      icon: ServiceIcon1,
    },
  ]


  const servicesContactSubmit = (values) => {
     // EmailJS configuration
     const serviceID = 'service_h7c337b';
     const templateID = 'template_sidynbr';
     const userID = 'MYhJGkvgTgncsGRU4';
 
     const templateParams = {
       from_name: values.name,
       email: values.email,
       number: values.phone,
       message: message,
     };
 
     emailjs.send(serviceID, templateID, templateParams , userID)
       .then((response) => {
          console.log(response , "response")
          console.log('SUCCESS!', response.status, response.text);
          // alert('Message sent successfully!');
          navigate('/Thankyou')
       })
       .catch((error) => {
         console.log('FAILED...', error);
         alert('Failed to send message.');
       });
  }



  return (
    <div className="OurServices">
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>White Tower - Services</title>
      </Helmet>
      <div className="main-services-section">
        <section className="services-section-1">
          <div className="inner-services-section-1">
            <div className="container">
              <div className="services-section-1-heading">
                <h1>OUR SERVICES</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="services-section-2">
          <div className="inner-services-sec-2">
            <div className="container">
              <div className="grid grid-cols-3 gap-5 all-services-gird-section">
                {ourServicesCards.map((items , index) => {
                  return (
                    <div className="similar-services-blk single-services-blk-1 wow animate__animated animate__fadeInUp" key={index}>
                      <div className="services-sec-top-part">
                        <div className="services-icon-sec">
                          <img src={items.icon} alt="" />
                        </div>
                        <div className="services-blk-heading">
                          <h4>{items.title}</h4>
                        </div>
                      </div>
                      <div className="services-sec-bottom-part">
                        <p>{items.content}</p>
                        {/* <button><p>Know More</p></button> */}
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </section>
        <section className="services-section-3">
          <div className="inner-services-section-2 h-full">
            <div className="container h-full">
              <div className="grid grid-cols-3 h-full">
                <div className="single-blurring-servises activer flex items-end">
                  <div className="inner-single-services-blur activer">
                      <div className="blur-service-head">
                        <h4>Track Record</h4>
                      </div>
                      <div className="blur-service-content">
                        <p>With a proven track record of successful cargo handling, White Tower International LLC has earned the trust of numerous clients across various industries. Our reliability, efficiency, and commitment to excellence have made us a preferred partner for businesses looking for quality logistics solutions that drive results.</p>
                      </div>
                  </div>
                </div>
                <div className="single-blurring-servises flex items-end">
                  <div className="inner-single-services-blur">
                      <div className="blur-service-head">
                        <h4>Experience</h4>
                      </div>
                      <div className="blur-service-content">
                        <p>White Tower International LLC boasts years of experience in cargo handling and logistics. Our knowledgeable team understands the complexities of the industry, ensuring that your goods are handled safely and efficiently. Trust us to deliver tailored solutions that meet your specific business needs with precision and care.</p>
                      </div>
                  </div>
                </div>
                <div className="single-blurring-servises flex items-end">
                  <div className="inner-single-services-blur">
                      <div className="blur-service-head">
                        <h4>Customer Approach</h4>
                      </div>
                      <div className="blur-service-content">
                        <p>At White Tower International LLC, we believe in building strong relationships with our clients. Our customer-centric approach focuses on understanding your unique needs and providing personalized support. We are committed to fostering long-term partnerships that empower your business and ensure a seamless logistics experience.</p>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="services-section-4">
          <div className="inner-services-section-3">
            <div className="container">
              <div className="services-contact-grid-section grid grid-cols-2">
                <div className="services-contact-section-left wow animate__animated animate__fadeInLeft">
                  <div className="services-contact-header">
                    <h2>CONTACT US</h2>
                    <p className='w-3/4'>Connect with us today for all your cargo handling needs and discover how we can help.</p>
                  </div>
                  <div className="support-services-sec">
                    <h4>Support Center</h4>
                    <div className="inner-contact-list flex flex-col gap-10 mt-10">
                      <div className="single-contact-list-sec flex items-center gap-7">
                          <div className="left-contact-icon">
                            <img src={CallSvg} alt="" />
                          </div>
                          <div className="right-contact-text">
                            <a href="tel:+96895967179">+96895967179</a>
                          </div>
                      </div>
                      <div className="single-contact-list-sec flex items-center gap-7">
                          <div className="left-contact-icon">
                            <img src={MailSvg} alt="" />
                          </div>
                          <div className="right-contact-text">
                            <a href="mail:whitetowerinternational@gmail.com">whitetowerinternational@gmail.com</a>
                          </div>
                      </div>
                      <div className="single-contact-list-sec flex items-center gap-7">
                          <div className="left-contact-icon">
                            <img src={LocationSvg} alt="" />
                          </div>
                          <div className="right-contact-text">
                            <a >Sohar , Oman </a>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="services-contact-section-right relative wow animate__animated animate__fadeInRight">
                  <Formik
                    validationSchema={contactFormValidation}
                    initialValues={ourServicesContactForm}
                    onSubmit={(values) => servicesContactSubmit(values)}
                  >
                    {({  errors, touched }) => (
                        <Form>
                            <div className="services-form-inner-section">
                              <div className={`${errors.name && errors.email && errors.phone ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'} duration-500   error-message absolute flex items-center gap-5 top-8 left-8 bg-red-100 bg-opacity-100 border border-red-600 px-5 py-2 w-10/12 `}>
                                <img src={ErrorSvg} className='w-5 h-5' alt="" />
                                <p className='text-red-600 font-bold'>Please Fill out Required Feilds</p>
                              </div>
                              <div className="inner-services-form-section grid grid-cols-2 gap-7">
                                  <div className="single-services-contact-input-sec">
                                      <div className="top-lable-section-services">
                                        <p>NAME</p>
                                      </div>
                                      <div className="input-services-sec mt-2">
                                        <Field type="text" name="name" placeholder='Enter Name' 
                                          className={`outline-none border px-5 py-3 bg-white w-full duration-500  ${errors.name && touched.name ? 'inputError border-red-500 border-opacity-100 bg-red-100 bg-opacity-100 placeholder:text-red-500' : 'border-white border-opacity-0 placeholder:text-black'}`} 
                                        />
                                      </div>
                                  </div>
                                  <div className="single-services-contact-input-sec">
                                      <div className="top-lable-section-services">
                                        <p>PHONE</p>
                                      </div>
                                      <div className="input-services-sec mt-2">
                                        <Field type="number" name="phone" placeholder='Enter Mobile Number'
                                          onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                          className={`outline-none border px-5 py-3 bg-white w-full duration-500  ${errors.phone && touched.phone ? 'inputError border-red-500 border-opacity-100 bg-red-100 bg-opacity-100 placeholder:text-red-500' : 'border-white border-opacity-0 placeholder:text-black'}`} 
                                        />
                                      </div>
                                  </div>
                                  <div className="single-services-contact-input-sec col-span-2">
                                      <div className="top-lable-section-services">
                                        <p>EMAIL</p>
                                      </div>
                                      <div className="input-services-sec mt-2">
                                        <Field type="email" name="email" placeholder='Enter Email' 
                                          className={`outline-none border px-5 py-3 bg-white w-full duration-500  ${errors.email && touched.email ? 'inputError border-red-500 border-opacity-100 bg-red-100 bg-opacity-100 placeholder:text-red-500' : 'border-white border-opacity-0 placeholder:text-black'}`} 
                                        />
                                      </div>
                                  </div>
                                  <div className="single-services-contact-input-sec col-span-2">
                                      <div className="top-lable-section-services">
                                        <p>COMMENT</p>
                                      </div>
                                      <div className="input-services-sec mt-2">
                                        <textarea placeholder='Enter Your Message' className='resize-none w-full px-5 py-4 h-40' onChange={(e) => setMessage(e.target.value)} name="" id=""></textarea>
                                      </div>
                                  </div>
                              </div>
                              <div className="form-submit-section-services">
                                <button type="submit">
                                  <p className=''>SUBMIT</p>
                                </button>
                              </div>
                            </div>
                        </Form>
                      )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

OurServices.propTypes = {};

OurServices.defaultProps = {};

export default OurServices;
